import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Sales Funnel" link="https://my-free-course.com/" bg="linear-gradient(to right, #D4145A 0%, rgba(255,255,0,0.6) 100%)" mdxType="ProjectCard">
  A Sales Funnel page written in Next.js, React & STRAPI
    </ProjectCard>
    <ProjectCard title="Zombie Game" link="https://hordezee.com/" bg="linear-gradient(to right, #317EC6 0%, rgba(255,0,0,0.5) 100%)" mdxType="ProjectCard">
  A Zombie game written in Node, Express & Postgres
    </ProjectCard>
    <ProjectCard title="Linktree" link="https://links.morganpage.tech/" bg="linear-gradient(to right, rgba(255,255,0,0.1) 0%, #FBB03B 100%)" mdxType="ProjectCard">
  A Linktree page written in vanilla JavaScript and plain CSS
    </ProjectCard>
    <ProjectCard title="Survival Game" link="https://survive.morganpage.tech/" bg="linear-gradient(to right, #D4145A 0%, #2E93E9 100%)" mdxType="ProjectCard">
  A Survival game written in JavaScript & Phaser
    </ProjectCard>
    <ProjectCard title="Blog" link="https://blog.morganpage.tech/" bg="linear-gradient(to left, #805AD5 0%, #FBB03B 100%)" mdxType="ProjectCard">
  A blog solution written in Next.js, React & STRAPI
    </ProjectCard>
    <ProjectCard title="Portfolio Site" link="https://portfolio.morganpage.tech/" bg="linear-gradient(to right, rgba(55,160,100,0.5) 0%, #FBB03B 100%)" mdxType="ProjectCard">
  This site! Uses Gatsby, a React-based, static site generator
    </ProjectCard>
    <ProjectCard title="Meme-it" link="https://hopeful-hodgkin-a3a70c.netlify.app/" bg="linear-gradient(to right, rgba(55,160,100,0.9) 0%, #11E9 100%)" mdxType="ProjectCard">
  Simple Vanilla JavaScript site showing the use of fetch() and the reddit API
    </ProjectCard>
    <ProjectCard title="The Sim Hub" link="https://thesimhub.com/" bg="linear-gradient(to left, rgba(255,0,0,0.1) 0%, #FBB03B 100%)" mdxType="ProjectCard">
  The platform for online interactive medical training, 
  WebGL experiences created in Babylon.js & Unity
    </ProjectCard>
    <ProjectCard title="eCommerce (coming soon)" link="https://my-free-course.com/" bg="linear-gradient(to left, rgba(255,0,0,0.1) 0%, #FBB03B 100%)" mdxType="ProjectCard">
  An eCommerce solution written in Python, Django & Vue
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      